module.exports = __webpack_public_path__ + "img/JoseVieira.6224e5cf.png";